// extracted by mini-css-extract-plugin
export default {"form":"CheckoutForm_form__T314X"};